<div *ngIf="hasData" class="jmWidgetPadding" id="interests">
	<div style="padding-bottom:20px">
		<span class="jmPageTitle">Interests</span>
	</div>
	<div id="interestSurveyEditor">
		<div class="row w-100" *ngFor="let result of RIASECObjs; let i=index;" style="margin-bottom:20px;">
			<div class="col-md-5 col-sm-6 col-12 jmSupportText" style="margin-top: -10px;">
				<div>
					<div class={{result.iconFont}} style="font-size: 25px; color: var(--bs-secondary); padding-right: 10px;"></div>
					<strong>{{result.label}}</strong>
					<div>
						Score:
						<input type="number" id="{{result.label}}" class="input-modal-text text-center" min="0" max="40" [(ngModel)]="RIASECObjs[i].value" (change)="changeScore(result)" [attr.defaultScore]="RIASECObjs[i].oldValue" />
					</div>
				</div>
				<div class="text-muted ellipsis-on-desktop-sm-view" [hidden]="interestsMobileDisplay">{{result.editTip}} </div>
			</div>
			<div class="col-md-7 col-sm-6 col-12" style="overflow: visible; margin-top:-10px; position:relative;">
				<div *ngIf="styleDict[result.label].visible" class="w-100" style="position: absolute; padding: 8px; width: 97% !important">
					<span style="position: absolute; top:-35px;" [ngStyle]="{'left': styleDict[result.label].widthAdjs }">
						<img [src]="styleDict[result.label].img" style="height: 40px; width:auto;" />
					</span>
				</div>
				<mat-slider class="w-100" min="0" max="40" step="1">
					<input matSliderThumb [(ngModel)]="RIASECObjs[i].value" (dragStart)="onSliderChanging($event, RIASECObjs[i])" (dragEnd)="onSliderChanging($event, RIASECObjs[i])" (valueChange)="onSliderChange($event, RIASECObjs[i])" (blur)="onSliderOut($event, RIASECObjs[i])">
				</mat-slider>
				<div *ngIf="hasTakenSurvey" class="w-100" style="pointer-events: none; position: absolute; padding: 8px; top: 11px;">
					<span style="background-color: #95A5A6; position: absolute; height: 10px; width: 10px; border-radius: 20px; left: 0;" [ngStyle]="{'left': styleDict[result.label].percent }" [title]="result.oldValue"></span>
				</div>
				<div clas="w-100" style="margin: 0px; top: -15px; position: relative;">
					<span class="float-start text-muted" style="padding-left:10px">0</span>
					<span class="float-end text-muted">40</span>
				</div>
			</div>
		</div>
	</div>
	<div class="w-100 text-end" style="margin-top: 10px;">
		<button class="btn btn-outline-primary" (click)="modalCancel()" [disabled]="saving" style="margin-right:20px;">Cancel</button>
		<button class="btn btn-primary" (click)="modalSave()" [disabled]="saving">Save</button>
	</div>
</div>

